"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateTimeValue = exports.TimeValue = exports.DateValue = void 0;
var __1 = require("..");
/**
 * Helper value class that stores a Moment object while appearing to be a {@link NumberValue}.
 *
 * Avoids unnecessary round-trip conversions when one function produces a date that is immediately consumed by another
 * date-wanting function.
 *
 * The numeric value is the Excel-style serial date.
 * @see serialDate
 */
var DateValue = /** @class */ (function () {
    function DateValue(moment) {
        this.type = __1.NumberType;
        this.moment = moment;
    }
    Object.defineProperty(DateValue.prototype, "value", {
        get: function () {
            return __1.serialDate(this.moment);
        },
        set: function (newVal) {
            this.moment = __1.coerceDate(newVal);
        },
        enumerable: false,
        configurable: true
    });
    return DateValue;
}());
exports.DateValue = DateValue;
/**
 * Helper value class that stores a Moment object while appearing to be a {@link NumberValue}.
 *
 * Avoids unnecessary round-trip conversions when one function produces a time that is immediately consumed by another
 * time-wanting function.
 *
 * The numeric value is the Excel-style serial time.
 * @see serialTime
 */
var TimeValue = /** @class */ (function () {
    function TimeValue(moment) {
        this.type = __1.NumberType;
        this.moment = moment;
    }
    Object.defineProperty(TimeValue.prototype, "value", {
        get: function () {
            return __1.serialTime(this.moment);
        },
        set: function (newVal) {
            this.moment = __1.coerceTime(newVal);
        },
        enumerable: false,
        configurable: true
    });
    return TimeValue;
}());
exports.TimeValue = TimeValue;
/**
 * Helper value class that stores a Moment object while appearing to be a {@link NumberValue}.
 *
 * Avoids unnecessary round-trip conversions when one function produces a datetime that is immediately consumed by
 * another datetime-wanting function.
 *
 * The numeric value is the Excel-style serial date added to the serial time.
 * @see serialDate
 * @see serialTime
 */
var DateTimeValue = /** @class */ (function () {
    function DateTimeValue(moment) {
        this.type = __1.NumberType;
        this.moment = moment;
    }
    Object.defineProperty(DateTimeValue.prototype, "value", {
        get: function () {
            return __1.serialDate(this.moment) + __1.serialTime(this.moment);
        },
        set: function (newVal) {
            var time = __1.coerceTime(newVal);
            this.moment = __1.coerceDate(Math.floor(newVal)).set({
                hour: time.hour(),
                minute: time.minute(),
                second: time.second(),
            });
        },
        enumerable: false,
        configurable: true
    });
    return DateTimeValue;
}());
exports.DateTimeValue = DateTimeValue;
//# sourceMappingURL=dateValues.js.map